import { TextField } from "@mui/material";
import React, { useContext, useState } from "react";
import { AppContext } from "../context/AppContext";

const AccountSelectInputWhite = (props) => {
  const { textHandler, readOnly = false } = props;
  const {accountId, setAccountId} = useContext(AppContext)

  const onEnterAccountId = (event) => {
    setAccountId(event.target.value);
    if (textHandler) textHandler(event.target.value);
  };

  return (
    <TextField
      label="Account ID"
      name="accountId"
      placeholder="Enter Account Id"
      value={accountId}
      onChange={onEnterAccountId}
      variant="standard"
      InputProps={{ readOnly }}
      sx={{
        width: "100%",
        "& .MuiInputBase-root": {
          backgroundColor: "transparent",
        },
        "& .MuiInputBase-root:before": {
          borderBottom: "1px solid #ffffff",
        },
        "& .MuiInputBase-root:hover:not(.Mui-disabled):before": {
          borderBottom: "1px solid #ffffff",
        },
        "& .MuiInputBase-root:after": {
          borderBottom: "none",
        },
        "& .MuiInputBase-input": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          color: "#ffffff",
          "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px #121212 inset",
            WebkitTextFillColor: "#ffffff !important",
            caretColor: "#ffffff !important",
            transition: "background-color 9999s ease-in-out 0s",
          },
        },
        "& .MuiFormLabel-root": {
          color: "#ffffff",
        },
        "& .MuiFormLabel-root.Mui-focused": {
          color: "#ffffff",
        },
        "& .Mui-focused .MuiInputBase-root": {
          backgroundColor: "transparent",
        },
      }}
    />
  );
};

export default AccountSelectInputWhite;
